@for (html of htmls(); track $index) {
  <div [innerHTML]="html"></div>
}
